import React  from "react";
import ATMPageHeader from "src/components/UI/atoms/ATMPageHeader/ATMPageHeader";
import ATMPagination from "src/components/UI/atoms/ATMPagination/ATMPagination";
import ATMTable from "src/components/UI/atoms/ATMTable/ATMTable";
import SideNavLayout from "src/components/layouts/SideNavLayout/SideNavLayout";
import { isCheckActionsPermission } from "src/helpers/userAccessFun";
import {
  UserModuleActionTypes,
  UserModuleNameTypes,
} from "src/models/userAccess/UserAccess.model";

type Props = {
  onAddNew: () => void;
  getActionOptions:any;
  columns:any ;
  rows: any[];
  paginationProps: {
    isTableLoading: boolean;
    totalItems: number;
    page: number;
    rowsPerPage: number;
    searchValue: string;
    setPage: (newPage: number) => void;
    setRowsPerPage: (newLimit: number) => void;
    setSearchValue: (newValue: string) => void;
  };
};

const QuestionBankListing = ({
  rows,
  getActionOptions ,
  onAddNew,
  columns ,
  paginationProps: {
    isTableLoading,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    setPage,
    setRowsPerPage,
    setSearchValue,
  },
}: Props) => {  
  return (
    <SideNavLayout>
      <div className="flex flex-col h-full">
        {/* Page Header */}
        <div className="p-4">
          <ATMPageHeader
            pageTitle="QuestionBanks"
            searchValue={searchValue}
            onSearchChange={setSearchValue}
            hideAddButton={
              !isCheckActionsPermission({
                moduleName: UserModuleNameTypes.QUESTION,
                actionName: UserModuleActionTypes.ADD,
              })
            }
            buttonProps={{
              btnName: "Add New",
              onClick: onAddNew,
            }}
          />
        </div> 
       

        {/* Table */}
        <div className="flex-1 overflow-auto flex flex-col p-4">
          <ATMTable
            rows={rows}
            columns={columns}
            rowExtraClasses={() => "min-h-[40px]"}
            isLoading={isTableLoading}
          />
        </div>
        {/* {isTableLoading ? (
          <div className="grid grid-cols-1 gap-3 overflow-auto w-full mt-3">
            {Array(4)
              .fill(null)
              .map((_, index) => (
                <div key={index} className="animate-pulse  h-[60px] p-2">
                  <div className="bg-slate-200 h-full rounded" />
                </div>
              ))}
          </div>
        ) : (
          <div className=" grid lg:grid-cols-3 sm:grid-cols-2 xs:grid-cols-1 gap-5 h-fit border-b py-2 mx-3 my-5">
            {rows?.map((el: any, index: any) => { 
                const options = getActionOptions(el?._id);
              return (
                <div key={index} className="shadow  h-fit bg-gray-50">
                  <div className="flex justify-end ">
                    <span className={` px-2 py-1 text-[12px] font-semibold rounded-md text-white ${ComplexityClasses(el?.complexity)?.class}`}>
                      {ComplexityClasses(el?.complexity)?.label}  
                     
                    </span> 
                  </div>
                  <div className="pl-3 flex justify-between">
                    <div className="font-medium text-[20px] flex items-center capitalize gap-3 pb-2 ">
                      <ATMMarkdownContainer markdown={el?.title} />
                    </div>
                    <div>
                    <ATMMenu options={options} orientation="vertical" />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )} */}

        <div className="p-4 py-2 flex justify-end">
          <ATMPagination
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={setPage}
            onRowsPerPageChange={setRowsPerPage}
            rowCount={totalItems}
            rows={rows}
          />
        </div>
      </div>
      
    </SideNavLayout>
  );
};

export default QuestionBankListing;
